import type { FC } from "react";
import { QuestionsManager } from "../../../projects/recruitingQuestions/questionsManager.js";
import type {
  QuestionsDispatch,
  QuestionWithTemporaryId,
} from "../../../projects/recruitingQuestions/questionsStore.js";

export interface QuestionsInterviewSectionDefinitionSettingsProps {
  questions: readonly QuestionWithTemporaryId[];
  onQuestionsChange: QuestionsDispatch;
}

export const QuestionsInterviewSectionDefinitionSettings: FC<
  QuestionsInterviewSectionDefinitionSettingsProps
> = (props) => {
  return (
    <QuestionsManager
      questions={props.questions}
      onQuestionsChange={props.onQuestionsChange}
    />
  );
};
